import(/* webpackMode: "eager" */ "/data/subvol-109-disk-1/data/php/www/evtolto-web/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/evtolto-web-stage/components/CookieConsent.tsx");
